import { cva } from 'class-variance-authority';

/** Ink tone of icon + spinner. `inherit` adds no class — the brick paints currentColor. */
export const INK_TONES = {
  inherit: '',
  ink: 'text-ink',
  c2: 'text-c2',
  c3: 'text-c3',
  acc: 'text-acc',
  acc2: 'text-acc2',
  'acc-muted-ink': 'text-acc-muted-ink',
  'on-acc': 'text-on-acc',
  ok: 'text-ok',
  warn: 'text-warn',
  bad: 'text-bad',
  destructive: 'text-destructive',
} as const;

export type InkTone = keyof typeof INK_TONES;

export const inkToneVariants = cva('', {
  variants: { tone: INK_TONES },
  defaultVariants: { tone: 'inherit' },
});
